<div class="modal-header">
  <h4 class="modal-title">Share A Copy With Your Client</h4>
</div>
<div class="modal-body">
  <p>Continuing will securely send this document through the TXdocs Online Intake Portal using Document Exchange.</p>
  <p>
    Client:
    <strong>{{ clientName }}</strong>
  </p>
  <p>
    Case:
    <strong>{{ caseName }}</strong>
  </p>
  <tx-file-type-selector
    class="w-100"
    (extensionChange)="extensionChange($event)"
    [(fileName)]="fileName"
    (fileNameChange)="handleFileNameChange($event)"
    defaultFileType=".pdf"
    [disableFileType]="isPdf"></tx-file-type-selector>
  <div *ngIf="fileNameInvalid" @expandCollapse class="text-center text-bg-danger p-1">
    The specified filename already has been uploaded.
  </div>
  <div class="form-floating mt-4">
    <textarea
      id="descriptionOfClientDocument"
      type="text"
      rows="5"
      ngbAutofocus
      class="form-control h-100"
      placeholder="Description Client Will See"
      [(ngModel)]="description"
      #descriptionOfClientDocument></textarea>
    <label for="descriptionOfClientDocument">Description of the file</label>
  </div>
</div>
<div class="modal-footer">
  <div
    tabindex="0"
    role="button"
    placement="top"
    ngbPopover="The specified filename already has been uploaded!"
    triggers="mouseenter:mouseleave"
    [disablePopover]="!fileNameInvalid">
    <button type="button" class="btn btn-primary" (click)="activeModal.close()" [disabled]="fileNameInvalid">
      Send
    </button>
    <button type="button" class="btn" (click)="activeModal.dismiss()">Cancel</button>
  </div>
</div>
